import script from "./AllActivePrayers.vue?vue&type=script&setup=true&lang=js"
export * from "./AllActivePrayers.vue?vue&type=script&setup=true&lang=js"

import "./AllActivePrayers.vue?vue&type=style&index=0&id=963aa58e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-963aa58e"]])

export default __exports__